import { createAsyncThunk } from '@reduxjs/toolkit';
import { paidSearchService } from '../../services';

const getPaidSearch = createAsyncThunk(
    'paidSearch/getPaidSearch',
    async (payload, thunkAPI) => {
        try {
            const response = await paidSearchService.getPaidSearch(payload.companyId, payload.startDate,payload.endDate);
            return response.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.message);;
        }
    }
);

export { getPaidSearch };
